function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import Vue from 'vue';
import Dialog from './dialog'; // 获取构造方法

var DialogConstruct = Vue.extend(Dialog);

function show(props) {
  var _props$appendTo = props.appendTo,
      appendTo = _props$appendTo === void 0 ? document.body : _props$appendTo;
  var dialogInstance;

  var close = function close(callback) {
    if (!dialogInstance) return; // 销毁动画

    dialogInstance.visible = false;
    setTimeout(function () {
      var _ref;

      // 删除dom
      (_ref = props.appendTo || document.body) === null || _ref === void 0 ? void 0 : _ref.removeChild(dialogInstance.$el); // 销毁实例

      dialogInstance.$destroy();
      dialogInstance = null; // 回调

      callback === null || callback === void 0 ? void 0 : callback();
    }, 510);
  };

  var init = function init() {
    // 创建实例
    dialogInstance = new DialogConstruct({
      el: document.createElement('div'),
      propsData: _objectSpread(_objectSpread({}, props), {}, {
        visible: true
      })
    }); // 添加dom到body里面

    appendTo.appendChild(dialogInstance.$el); // ok

    dialogInstance.$on('ok', function () {
      close(props.onOk);
    }); // cancel

    dialogInstance.$on('cancel', function () {
      close(props.onCancel);
    }); // close

    dialogInstance.$on('close', function () {
      close(props.onClose);
    });
  };

  var update = function update(props) {
    if (!dialogInstance) return;
    Object.keys(props).forEach(function (key) {
      dialogInstance[key] = props[key];
    });
  };

  init();
  return {
    update: update,
    close: close
  };
}

var alert = function alert(props) {
  var defaultProps = {
    showCancel: false
  };
  return show(_objectSpread(_objectSpread({}, defaultProps), props));
};

var confirm = show;
export default {
  show: show,
  alert: alert,
  confirm: confirm
};